import moment from "moment";
import { paymentMethods, membershipTypes, occupations } from "../constants";
import { checkIfTracking } from "./form-utils";
import { v4 as uuidv4 } from "uuid";

const itemIdGuid = uuidv4();
const isTracking = checkIfTracking();

//Disse kan ikke ændres efter behov da MOS kun kan tage imod bestemte tekster.
const occupationLabels = {
    [occupations.employed]: "I arbejde",
    [occupations.student]: "Under uddannelse",
    [occupations.unemployed]: "Ledig",
    [occupations.selfEmployed]: "Selvstændig",
    [occupations.trainee]: "Trainee",
    [occupations.vocationalEducation]: "Under uddannelse",
};

function assembleDto(data, flowsteps, steps) {
    function getUddannelsetype() {
        const education = data.EducationChoice;
        if (
            data.IsRecentGraduate === true ||
            moment(data.EducationEndDate).isSameOrBefore(moment(), "day")
        ) {
            return "Finished";
        }
        if (education.IsTheoretical) {
            return "Videregående";
        }
        if (education.IsBasic && !education.IsFolkeskole) {
            return "Ungdom";
        }
        if (education.IsFolkeskole) {
            return "Folkeskole";
        }
        if (education.IsPractical) {
            return "Elev";
        }
        if (data.EducationChoiceManual) {
            return "Other";
        }
    }

    function getUddannelsesstatus() {
        if (data.IsRecentGraduate === true) {
            return "Jeg er færdig med min uddannelse";
        }
        if (
            data.MemberSituation === occupations.student ||
            data.MemberSituation === occupations.trainee ||
            data.MemberSituation === occupations.vocationalEducation
        ) {
            return moment(data.EducationEndDate).isSameOrBefore(moment(), "day")
                ? "Jeg er færdig med min uddannelse"
                : "Jeg er i gang med min uddannelse";
        }
        return "";
    }

    function getAkasse(akasseLabel) {
        const allUnimploymentInsuranceFunds = steps.find(
            (step) => step.Component === "AKassePreviousFundInformation"
        ).Inputs.CurrentUnemploymentInsuranceFund.Options;
        const akasseValue = allUnimploymentInsuranceFunds.find(
            (fund) => fund.Label === akasseLabel
        ).Value;
        return akasseValue;
    }

    function getFaerdigUddannetSom() {
        if (
            data.MemberSituation === occupations.unemployed ||
            data.IsRecentGraduate
        ) {
            return data.EducationChoice.DunCode === "0"
                ? data.EducationChoiceManual
                : data.EducationChoice.Education;
        }
    }

    const EducationChoice = data.EducationChoice
        ? {
              CrmId: data.EducationChoice.CrmId,
              DunkodeId: data.EducationChoice.DunCode,
              Uddannelsesnavn:
                  data.EducationChoice.DunCode === "0"
                      ? data.EducationChoiceManual
                      : data.EducationChoice.Education,
              FaerdiguddannetSom: getFaerdigUddannetSom(),
              Uddannelsetype: getUddannelsetype(),
          }
        : {};

    let workplace = {};
    if (data.Workplace && data.Workplace.Name && data.Workplace.CrmId) {
        workplace = {
            ArbejdsgiverId: data.Workplace.CrmId,
            ArbejdsgiverNavn: data.Workplace.Name,
            ArbejdsgiverAdresse: data.Workplace.Address,
            ArbejdsgiverPostnummer: data.Workplace.Zip.split(" ")[0], // Since Zip value looks like "8000 Aarhus C"
            ArbejdsgiverBy: data.Workplace.City,
        };
    } else if (data.CompanyName) {
        workplace = {
            ArbejdsgiverNavn: data.CompanyName,
            ArbejdsgiverAdresse: data.CompanyAddress,
            ArbejdsgiverPostnummer: data.CompanyPostalCode,
            ArbejdsgiverBy: data.CompanyCity,
        };
    }

    let jobPosition = {};
    if (data.JobPosition && data.JobPosition.JobPositionId !== "0") {
        jobPosition = {
            DiscokodeId: data.JobPosition.DiscoId,
            StillingsbetegnelseId: data.JobPosition.JobPositionId,
            StillingsbetegnelseText: data.JobPosition.JobPosition,
            // Stilling: null, not used
        };
    } else if (data.JobPositionManual) {
        jobPosition = {
            StillingsbetegnelseText: data.JobPositionManual,
        };
    }
    console.log("preAssembled formvalues", data);

    const getConsents = () => {
        let listOfConsents = [];
        //we consider the user seeing it and not checking as a NO
        if (data.MembershipType === membershipTypes.Union) {
            listOfConsents.push({
                SamtykkeTypeId: data.TerminationReferenceValue,
                SamtykkeTypeNavn: data.TerminationReferenceName,
                SamtykkeAfgivet:
                    data.ConsentInformationFromUnionToUnemploymentFundIfFired ==
                        undefined ||
                    data.ConsentInformationFromUnionToUnemploymentFundIfFired ==
                        ""
                        ? false
                        : data.ConsentInformationFromUnionToUnemploymentFundIfFired,
            });
        } else if (data.MembershipType === membershipTypes.UnemploymentFund) {
            listOfConsents.push({
                SamtykkeTypeId: data.EmploymentReferenceValue,
                SamtykkeTypeNavn: data.EmploymentReferenceName,
                SamtykkeAfgivet:
                    data.ConsentInformationFromUnemploymentFundToUnionIfJobless ==
                        undefined ||
                    data.ConsentInformationFromUnemploymentFundToUnionIfJobless ==
                        ""
                        ? false
                        : data.ConsentInformationFromUnemploymentFundToUnionIfJobless,
            });
        } else {
            listOfConsents.push({
                SamtykkeTypeId: data.TerminationReferenceValue,
                SamtykkeTypeNavn: data.TerminationReferenceName,
                SamtykkeAfgivet:
                    data.ConsentInformationFromUnionToUnemploymentFundIfFired ==
                        undefined ||
                    data.ConsentInformationFromUnionToUnemploymentFundIfFired ==
                        ""
                        ? false
                        : data.ConsentInformationFromUnionToUnemploymentFundIfFired,
            });
            listOfConsents.push({
                SamtykkeTypeId: data.EmploymentReferenceValue,
                SamtykkeTypeNavn: data.EmploymentReferenceName,
                SamtykkeAfgivet:
                    data.ConsentInformationFromUnemploymentFundToUnionIfJobless ==
                        undefined ||
                    data.ConsentInformationFromUnemploymentFundToUnionIfJobless ==
                        ""
                        ? false
                        : data.ConsentInformationFromUnemploymentFundToUnionIfJobless,
            });
        }
        return listOfConsents;
    };
    const getAbsoluteMonths = (momentDate) => {
        const md = moment(momentDate).startOf("day");
        return md.month() + md.year() * 12;
    };
    const getComment = () => {
        let formattedComment = "";

        //Hvis man har valgt "andet" i uddannelse, ryger indmeldelsen til manuel behandling
        if (data.EducationChoiceManual) {
            formattedComment +=
                'Har valgt "andet" i listen over uddannelser. Praktisk/Teoretisk medlemstilstand er sat alt efter om bruger har valgt Elev eller Studerende som deres livssituation. Bruger har indtastet i uddannelsesfelt: ' +
                data.EducationChoiceManual +
                "\n\n";
        }

        if (
            data.EducationChoiceAfterFinishedEducation &&
            data.EducationChoiceAfterFinishedEducation.Education
        ) {
            formattedComment += "Starter ny uddannelse, som: ";
            formattedComment +=
                data.EducationChoiceAfterFinishedEducation.Education + "\n";
            if (data.EducationChoiceAfterFinishedEducationInstitution) {
                formattedComment +=
                    "Sted: " +
                    data.EducationChoiceAfterFinishedEducationInstitutionName +
                    "\n";
            }
            formattedComment +=
                "Startdato: " +
                moment(
                    data.EducationChoiceAfterFinishedEducationStartDate
                ).format("DD.MM.YYYY") +
                "\n";
            formattedComment +=
                "Slutdato: " +
                moment(
                    data.EducationChoiceAfterFinishedEducationEndDate
                ).format("DD.MM.YYYY") +
                "\n";

            if (data.StartNewEducationIsPractical) {
                formattedComment +=
                    "Modtager medlemmet offentlig forsørgelse: ";
                formattedComment += !!data.RecievesPublicWelfareNewEducation
                    ? "Ja"
                    : "Nej";
                formattedComment += "\n";
                if (!!data.RecievesPublicWelfareNewEducation === false) {
                    formattedComment +=
                        "Modtager medlemmet løn fra andre end arbejdsgiver?: ";
                    formattedComment +=
                        !!data.SalaryFromOtherThanEmployerNewEducation
                            ? "Ja"
                            : "Nej";

                    if (
                        !!data.SalaryFromOtherThanEmployerNewEducation === true
                    ) {
                        formattedComment += "\n";
                        formattedComment += "Medlemmets månedlige indkomst er ";
                        formattedComment +=
                            !!data.MonthlyIncomeOverLimitNewEducation
                                ? "over "
                                : "under ";
                        formattedComment += "grænsen før skat.";
                        formattedComment += "\n";
                    }
                }
            } else {
                formattedComment +=
                    "Er medlemmets månedlige indtægt over 25.451 kr. før skat, eller tager medlemmet sin uddannelse på revalidering: ";
                formattedComment += !!data.MonthlyIncomeOverLimitNewEducation
                    ? "Ja"
                    : "Nej";
                formattedComment += "\n";

                if (!!data.MonthlyIncomeOverLimitNewEducation === true) {
                    formattedComment += "Revalidering eller høj indkomst: ";
                    formattedComment +=
                        !!data.MonthlyIncomeLimitClarificationNewEducation
                            ? "Revalidering"
                            : "Medlemmet har en løn højere end grænsen.";
                    formattedComment += "\n";
                }
            }
            formattedComment += "\n";
        }

        //Hvis udd. er under 18 måneder skal indmeldelsen gå til manuel behandling med en kommentar om dette.
        if (
            (data.MemberSituation === occupations.student ||
                data.MemberSituation === occupations.vocationalEducation ||
                data.IsRecentGraduate === true) &&
            data.EducationStartDate &&
            data.EducationEndDate &&
            data.MembershipType != membershipTypes.Union
        ) {
            var startMonths = getAbsoluteMonths(data.EducationStartDate);
            var endMonths = getAbsoluteMonths(data.EducationEndDate);
            var monthDifference = endMonths - startMonths;
            if (monthDifference < 18)
                formattedComment += "Uddannelse varer under 18 måneder.\n\n";
        }

        if (data.MemberSituation === occupations.trainee) {
            formattedComment += "Trainee.\n\n";
        }

        if (data.QuestionsOrCommentsTextBox) {
            formattedComment += "Kommentar fra medlem:\n";
            formattedComment += data.QuestionsOrCommentsTextBox + "\n\n";
        }

        return formattedComment;
    };

    function getJobFunction() {
        let jobFunction;

        if (data.ManagementResponsibility) {
            jobFunction = parseInt(data.ManagementResponsibility, 10);
        } else {
            switch (data.MemberSituation) {
                case occupations.student:
                case occupations.vocationalEducation:
                    jobFunction = 1;
                    break;
                case occupations.trainee:
                case occupations.unemployed:
                case occupations.selfEmployed:
                    jobFunction = 9;
                    break;
            }
        }
        return jobFunction;
    }

    function getMembershipStartDate() {
        //HVIS MAN ER LEDIG OG SKAL SKIFTE SKAL MODULUS SELV FORETAGE BEREGNINGEN.
        if (
            data.MemberSituation === occupations.unemployed &&
            data.HasUnemploymentInsuranceFund === true
        ) {
            return moment().format("YYYY-MM-DD");
        }

        return (
            data.MembershipStartDate &&
            moment(data.MembershipStartDate).startOf("day").format("YYYY-MM-DD")
        );
    }

    function getJobSituation() {
        let jobSituationInDanish = data.MemberSituation
            ? occupationLabels[data.MemberSituation]
            : occupationLabels[occupations.unemployed];

        return jobSituationInDanish;
    }

    function getWeeklyHours() {
        if (data.Over30Hours || data.ReceivesWageSubsidies) {
            return 37;
        } else return 29;
    }

    function getKontoNr(kontoNr) {
        if (
            kontoNr === "0000000000" ||
            kontoNr === "1234567899" ||
            kontoNr === "1111111111" ||
            kontoNr === "1234567890"
        ) {
            return "";
        }
        return kontoNr;
    }

    function getRegNr(regNr) {
        if (
            regNr === "0000" ||
            regNr === "1234" ||
            regNr === "1111" ||
            regNr === "9999"
        ) {
            return "";
        }
        return regNr;
    }

    function getTilmeldNets(betalingsmetode, regNr, kontoNr) {
        if (betalingsmetode === paymentMethods.Betalingsservice) {
            if (
                (regNr === "0000" ||
                    regNr === "1234" ||
                    regNr === "1111" ||
                    regNr === "9999") &&
                (kontoNr === "0000000000" ||
                    kontoNr === "1234567899" ||
                    kontoNr === "1111111111" ||
                    kontoNr === "1234567890")
            ) {
                return false;
            }

            return true;
        }
        return false;
    }

    let MemberRegistrationID = Date.now();

    return {
        // Meta
        // RingMigOp: value, not used
        // Afbrudt: value, not used
        AKasse:
            data.MembershipType === membershipTypes.UnemploymentFund ||
            data.MembershipType === membershipTypes.UnionAndUnemploymentFund
                ? true
                : false,
        Fagforening:
            data.MembershipType === membershipTypes.Union ||
            data.MembershipType === membershipTypes.UnionAndUnemploymentFund
                ? true
                : false,
        Sprog: data.PreferredLanguage ? data.PreferredLanguage : "Dansk",

        // ContactInformation
        Navn: `${data.Firstname} ${data.Lastname}`,
        Fornavn: data.Firstname,
        Efternavn: data.Lastname,
        Cpr: data.CPR && data.CPR.replace("-", ""),
        Emailadr: data.Email,
        IngenEmailadr: !data.Email,
        Adresse: data.ManualAddress,
        CoAdresse: data.CareOf,
        Postnummer: data.ManualPostalCode,
        By: data.ManualCity,
        Mobil:
            data.Phone.substring(0, 4) === "0045"
                ? data.Phone.substring(4)
                : data.Phone,
        Fastnet: null,
        DanskStatsborger:
            data.IsCitizen !== undefined && data.IsCitizen !== ""
                ? data.IsCitizen
                : true,

        // Occupation
        Timetal: getWeeklyHours(),
        Flexjob: data.ReceivesWageSubsidies,

        //HEDDER "Uddannelse" i CRM
        UnderUddannelseEllerNyuddannet:
            data.MemberSituation === occupations.student ||
            data.MemberSituation === occupations.vocationalEducation ||
            data.IsRecentGraduate === true,

        Uddannelsesstart:
            data.EducationStartDate &&
            moment(data.EducationStartDate).startOf("day").format("YYYY-MM-DD"),
        Uddannelsesslut:
            data.EducationEndDate &&
            moment(data.EducationEndDate).startOf("day").format("YYYY-MM-DD"),
        // Regarding "max dp sats"
        TjenerMereEnd:
            data.MonthlyIncomeOverLimit === undefined ||
            data.MonthlyIncomeOverLimit === null
                ? null
                : data.MonthlyIncomeOverLimit,

        BopaelIDkIndenUddannelsesStart: data.HasResidence,
        LoennetArbejdeVedSidenAfStudier: data.StudyJob,
        ErPaaEnArbejdsplads: !!workplace.ArbejdsgiverNavn || null,
        Indkomsttype:
            data.MonthlyIncomeOverLimit === true &&
            data.SalaryFromOtherThanEmployer
                ? data.SalaryFromOtherThanEmployer
                : null,
        JobSituation: getJobSituation(),
        PaabegynderNyUddannelse: data.StartNewEducation,

        //// Unemployment Insurance Fund
        MedlemAfAndenAkasse: data.HasUnemploymentInsuranceFund || null,
        NuvaerendeAkasse:
            data.CurrentUnemploymentInsuranceFund &&
            data.CurrentUnemploymentInsuranceFund !== "Anden A-kasse"
                ? getAkasse(data.CurrentUnemploymentInsuranceFund)
                : null,
        NuvaerendeAkasseFritekst:
            data.ManualCurrentUnemploymentInsuranceFund || null,

        TidligereAkasse:
            data.PreviousUnemploymentInsuranceFund &&
            data.PreviousUnemploymentInsuranceFund !== "Anden A-kasse"
                ? getAkasse(data.PreviousUnemploymentInsuranceFund)
                : null,
        TidligereAkasseFritekst:
            data.ManualPreviousUnemploymentInsuranceFund || null,
        HarTidligereVaeretMedlemAfAndenAkasse:
            data.HasPreviousUnemploymentInsuranceFund || null,

        SocialeYdelser:
            data.RecievesPublicWelfare || data.MonthlyIncomeLimitClarification,
        SelvstaendigVirksomhed: data.CompanyName || null,
        SelvstaendigVirksomhedCvr: data.CompanyCvr || null,

        //// Kontingent
        DatoForMedlemskab: getMembershipStartDate(),
        TilmeldNets: getTilmeldNets(
            data.PaymentMethod,
            data.RegNr,
            data.KontoNr
        ),
        DeltidsForsikret:
            data.PartTimeMembershipFlag || data.PartTimeMembership || false,
        TilmeldHKMedlemsfordeleNyhedsbrev:
            data.ConsentRecieveFromUnemploymentFund,
        //not used in MemApp either: MedlemskategoriId: value,
        MedarbejderId: data.empId,
        CrmUserId: data.empId,
        RegNr: getRegNr(data.RegNr),
        Kontonummer: getKontoNr(data.KontoNr),
        Land: data.Country ? data.Country : "DK",
        UdenlandskZip: data.ForeignAddressPostalCode || undefined,
        Jobfunktion: getJobFunction(),
        GratisAkasseFravalgt: false,
        EgenVirksomhed:
            data.HasCompany ||
            data.MemberSituation === occupations.selfEmployed,
        RetTilNyuddannetDagpengesats: data.SkipAkasseFlag
            ? null
            : data.hasDimittendBerettigetEducation,
        Uddannelsesstatus: getUddannelsesstatus(),
        ...EducationChoice,
        ...workplace,
        ...jobPosition,
        UddanelsesstedCrmId: data.EducationInstitution
            ? data.EducationInstitution
            : undefined, //if left empty, MOS fills in "unknown educationsite" (ukendt uddannelsessted)
        Bemaerkninger: getComment(),
        SamtykkeList: getConsents(),
        BetalingsMetode:
            data.PaymentMethod === paymentMethods.Giro
                ? paymentMethods.Betalingsservice
                : data.PaymentMethod,
        MemberRegistrationID: MemberRegistrationID,
        PayFirstRateNow: data.PayFirstRateNow,
        PaymentMethod: data.PaymentMethod,
        ItemId: itemIdGuid,
        IsTracking: isTracking,
    };
}

export default assembleDto;
